<template>
  <v-container>
    <v-row class="mb-4" justify="space-between" align-content="center">
      <h1 class="text text-h4 titulo">Ventas por Producto</h1>
      <export-sales-by-product :data="products"/>
    </v-row>
    <v-row>
      <v-col cols="4">
        <sales-product-graph 
        :data="sortedData.bySales" 
        :icon="'fas fa-money-bill-wave'" 
        :values="sortedData.bySales.map(d=>d.total_sales)"
        :height="150"
        title="Ranking Ventas"
        />
      </v-col>
      <v-col cols="4">
        <sales-product-graph 
        :data="sortedData.byMts2" 
        :icon="'square_foot'" 
        :values="sortedData.byMts2.map(d=>d.total_mts2)"
        :height="150"
        title="Ranking Mts2"
        />
      </v-col>
      <v-col cols="4">
        <sales-product-graph 
        :data="sortedData.byQty" 
        :icon="'square_foot'" 
        :values="sortedData.byQty.map(d=>d.total_qty)"
        :height="150"
        title="Ranking Cantidad"
        />
      </v-col>
    </v-row>
    <v-card class="pa-4">
      <v-row class="" >
        <v-col align-self="center">
          <v-text-field hide-details :disabled="loading" dense v-model='filter.created_after' class="mr-4" outlined clearable type="date" label="Creada Desde:"></v-text-field>
        </v-col>
        <v-col align-self="center">
          <v-text-field hide-details :disabled="loading" dense v-model='filter.created_before' clearable outlined type="date" label="Creada Hasta:" ></v-text-field>
        </v-col>
        <v-col align-self="center">
          <v-text-field
            v-model="search"
            label="Buscar"
            append-icon="fas fa-search"
            :disabled="loading"
            hide-details
            
          ></v-text-field>
        </v-col>
      </v-row>
        <v-row justify="center">
          <v-col>
            <v-data-table
          :headers="headers"
          :items="products"
          :search="search"
          sort-by="total_sales"
          :item-class="itemRowStyle"
          :sort-desc="true"
          :loading="loading"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'fas fa-angle-double-left',
            lastIcon: 'fas fa-angle-double-right',
            prevIcon: 'fas fa-angle-left',
            nextIcon: 'fas fa-angle-right',
            itemsPerPageOptions: [10, 20, 30, 40, 50,100],
          }"
          @click:row="onClickRow"
        >
          
          <template v-slot:item.total_sales="{ item }">
            {{item.total_sales | currency('$', 0)}}
          </template>
          <template v-slot:item.total_mts2="{item}">
              {{item.total_mts2 | number('0,0.00')}}
          </template>
          <template v-slot:item.total_qty="{item}">
              {{item.total_qty | number('0,0.00')}}
          </template>
          </v-data-table>
          </v-col>
          
        </v-row>
    </v-card>
    <v-dialog v-model="toDetail" max-width="1200">
      <v-card class="pa-2 px-4">
        <v-card-title class="titulo text-h5">[{{product.sku}}] {{product.name}}</v-card-title>
        <product-sales-report-detail
        :sku="product.sku"
        :filter="filter"
        :product="product"
        />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {fetchProductionProducts} from '@/api/reports'
import SalesProductGraph from '@/components/reports/SalesProductGraph'
import ExportSalesByProduct from '@/components/reports/ExportSalesByProduct'
import ProductSalesReportDetail from '@/components/reports/ProductSalesReportDetail'
import moment from 'moment'
export default {
  name:"ProductSalesReport",
  components:{SalesProductGraph,ExportSalesByProduct,ProductSalesReportDetail},
  created(){
    this.fetch()
  },
  data() {
    return {
      loading: false,
      filter:{
        created_after:moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('yyyy-MM-DD'),
        created_before:'',
      },
      search:'',
      products:[],
      product:'',
      toDetail:false,
      headers:[
          {text: 'Código',align: 'start',value: 'sku',class: 'table-header2'},
          {text: 'Descripción',align: 'start',value: 'name',class: 'table-header2'},
          {text: 'Familia',value:'family',class: 'table-header2'},
          {text: 'Línea',align: 'start',value: 'line',class: 'table-header2'},
          {text: 'Mts2',align: 'end',value: 'total_mts2',class: 'table-header2'},
          {text: 'Cantidad',align: 'end',value: 'total_qty',class: 'table-header2'},
          {text: 'Venta',align: 'end',value: 'total_sales',class: 'table-header2'},
        ]
    }
  },
  methods:{
    onClickRow(item){
      this.product = item
      this.toDetail = true
    },
    async fetch(){
      this.loading=true
      //Arreglando variables de fecha en caso de ser null
      if(!this.filter.created_after) this.filter.created_after=''
      if(!this.filter.created_before) this.filter.created_before=''
      //const {sortBy, sortDesc,page, itemsPerPage }=this.options
      await fetchProductionProducts(this.filter.created_after,this.filter.created_before)
      .then((res)=>{
        this.loading=false
        console.log(res)
        this.products=this.processData(res)
      })
      .catch((err)=>{
        this.loading=false
        notifications.showError(err)
      })
    },
    processData(rawProducts){
      
      let unique = [...new Set(rawProducts.map(item =>
        item.library_product
      ))];
      const results=unique.map(product=>{
        const productionProducts=rawProducts.filter(p=> p.library_product==product)
        console.log(product)
        console.log('productionProducts',productionProducts)
          //total_sales=productionProducts.reduce((acc, val)=>{ return acc + parseFloat(val.total_sales_price); }, 0)
        return{
          id:product,
          name:productionProducts[0].library_product_name,
          sku:productionProducts[0].sku,
          family:productionProducts[0].family_name,
          line:productionProducts[0].line_name,
          total_sales:productionProducts.reduce((acc, val)=>{ return acc + parseFloat(val.total_sales_price); }, 0),
          total_mts2:productionProducts.reduce((acc, val)=>{ return acc + parseFloat(val.mts2); }, 0),
          total_qty:productionProducts.reduce((acc, val)=>{ return acc + parseFloat(val.qty); }, 0),
          production_products:productionProducts
        }
      })
      return results
    },
    itemRowStyle(item){
      return 'row-style-normal'
    },
  },
  watch:{
    filter:{
      deep: true,
      handler: 'fetch'
    },
  },
  computed:{
    sortedData(){
      const products = this.products
      const bySales = products.sort((a, b) => { return b.total_sales - a.total_sales }).slice(0, 5)
      const byMts2 = products.sort((a, b) => { return b.total_mts2 - a.total_mts2 }).slice(0, 5)
      const byQty = products.sort((a, b) => { return b.total_qty - a.total_qty }).slice(0, 5)
      return {
        bySales: bySales,
        byMts2: byMts2,
        byQty:byQty
      }
    }
  }

}
</script>

<style scoped>
  .row-style-normal{
    cursor: pointer;
  }

</style>